/**
 * Review company export route detection and PDF filename formatting, plus
 * re-exports for the export render page (pages/portfolio/review/_requestId/export/_ventureId.vue).
 */
export const REVIEW_COMPANY_EXPORT_ROUTE_PATTERN =
  /^\/portfolio\/review\/[^/]+\/export\/[^/]+/

export function isReviewCompanyExportRoute(path: string): boolean {
  return REVIEW_COMPANY_EXPORT_ROUTE_PATTERN.test(path)
}

/** Default PDF name when the user chooses Save as PDF (via document.title). */
export function buildReviewCompanyExportFileName(options: {
  companyName: string
  ventureId: string
  exportedAt?: Date
}): string {
  const { companyName, ventureId, exportedAt = new Date() } = options
  const fallback = `review-company-${ventureId}`
  const raw = companyName?.trim()
  let companyPart = fallback
  if (raw && raw !== '—') {
    const sanitized = raw
      .replace(/[\\/:*?"<>|]/g, ' ')
      .replace(/\s+/g, '_')
      .replace(/_+/g, '_')
      .replace(/^_|_$/g, '')
    if (sanitized) {
      companyPart = sanitized
    }
  }
  const dd = String(exportedAt.getDate()).padStart(2, '0')
  const mm = String(exportedAt.getMonth() + 1).padStart(2, '0')
  const yyyy = String(exportedAt.getFullYear())
  return `${dd}_${mm}_${yyyy}_${companyPart}_Impact_Strategy`
}

// Re-export document-side helpers for the review export page.
export {
  removeStaleCardExportIframes,
  deliverEmbeddedCardExport as deliverReviewCompanyExportEmbedded,
  deliverStandaloneCardExport as deliverReviewCompanyExportStandalone,
  failCardExport as failReviewCompanyExport,
} from '~/functions/client-card-export'
